import React, {useEffect, useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import {makeStyles} from "@material-ui/core";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import CorrespondenceService from "../../../services/CorrespondenceService";
import Loading from "../../Loading";
import moment from "libs/moment";
import DateFormats from "../../../constants/DateFormats";
import SimpleTable from "../simpleTable/SimpleTable";
import TooltipIcon from "../../icon/TooltipIcon";
import {Mail, MailOutline} from "@material-ui/icons";


export const createConfirmObject = (message, confirmFn, cancelFn) => {
    return {
        message,
        confirm: confirmFn,
        cancel: cancelFn
    }
}

const useStyle = makeStyles((theme) => ({
    bold: {
        fontWeight: theme.typography.fontWeightBold
    },
    buttonRow: {
        marginTop: theme.spacing(2),
        textAlign: "end"
    },
    lpColumn: theme.components.table.lpColumn,
    emailColumn: theme.components.table.emailColumn,
    ipColumn: theme.components.table.ipColumn,
    dateTimeColumn: {
        ...theme.components.table.dateTimeColumn,
        textAlign: 'center'
    }
}));

function MessageEmailDeliveryPopup(
    {
        recipient,
        messageId,
        rfxRoundId,
        onClose
    }) {


    const classes = useStyle();

    const [working, setWorking] = useState(true);
    const [deliveryList, setDeliveryList] = useState([]);

    useEffect(() => {

        let promise;
        if (!!recipient.invitedSupplier) {
            promise = CorrespondenceService.getBuyerMessageDelivery(rfxRoundId, messageId, 'invitedSupplier', recipient.invitedSupplier);
        } else if (!!recipient.contractorDepartmentId) {
            promise = CorrespondenceService.getBuyerMessageDelivery(rfxRoundId, messageId, 'contractorDepartment', recipient.contractorDepartmentId);
        } else {
            promise = CorrespondenceService.getBuyerMessageDelivery(rfxRoundId, messageId, 'external', messageId);
        }
        promise.then(x => setDeliveryList(x)).finally(() => setWorking(false));

    }, [recipient, messageId, rfxRoundId]);


    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton("OK", onClose, undefined, false));
        return buttons;
    }

    const getStatusCellContent = (item) => {
        return <span>
            {Tr(`message_delivery_status_${item.status}`)}
            {!!item.errorMessage && <>
                <br/><span className={classes.bold}>{Tr('details')}: </span>
                <span>${item.errorMessage}</span>
            </>}

        </span>
    }

    return (
        <Dialog
            title={Tr("message_delivery_status_title") + `: ${recipient.name}`}
            open={true}
            maxWidth='md'
            dialogActions={<MultiButton buttons={getButtons()} />}
        >
            {working && <Loading/>}
            {!working &&
            <SimpleTable
                columnClasses={[
                    classes.lpColumn,
                    classes.emailColumn,
                    undefined,
                    classes.dateTimeColumn,
                ]}
                headers={["", Tr('email'), Tr('status'), Tr('status_date')]}
                items={deliveryList.map((item, index) => [
                    <TooltipIcon color={item.status === 'FAILED' || item.status === 'EMAIL_BLOCKED' ? 'error' : ( item.status === 'SUSPENDED' ? 'secondary' : undefined )} Icon={item.status === 'SENT' ? Mail : MailOutline} tooltip={Tr(`message_delivery_status_info_${item.status}`)} />,
                    item.recipient,
                    getStatusCellContent(item),
                    item.deliveryDate ? moment(item.deliveryDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT) : '--'
                ])}
            />

            }

        </Dialog>
    )
}

export default MessageEmailDeliveryPopup;